module.exports = __webpack_public_path__ + "static/img/tuandui.bcf3e742.png";